import $ from 'jquery';

function initMap(index, map) {

  const mapCoords = {
    lat: parseFloat(map.dataset.mapLatitude),
    lng: parseFloat(map.dataset.mapLongitude)
  };

  const mapObject = new google.maps.Map(map, {
    center: mapCoords,
    zoom: 14,
    disableDefaultUI: true,
    draggable: false,
    scrollWheel: false,
    styles: [{
        elementType: 'geometry',
        stylers: [{
          color: '#F2F2F2'
        }]
      },
      {
        elementType: 'labels.text.stroke',
        stylers: [{
          color: '#ffffff'
        }]
      },
      {
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#454545'
        }]
      },
      {
        featureType: 'administrative.locality',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#454545'
        }]
      },
      {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#454545'
        }]
      },
      {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [{
          color: '#F2F2F2'
        }]
      },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{
          color: '#fefefe'
        }]
      },
      {
        featureType: 'road',
        elementType: 'geometry.stroke',
        stylers: [{
          color: '#fefefe'
        }]
      },
      {
        featureType: 'road',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#454545'
        }]
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{
          color: '#E6E6E6'
        }]
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [{
          color: '#E6E6E6'
        }]
      },
      {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#ffffff'
        }]
      },
      {
        featureType: 'transit',
        elementType: 'geometry',
        stylers: [{
          color: '#efefef'
        }]
      },
      {
        featureType: 'transit.station',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#efefef'
        }]
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{
          color: '#DE8353'
        }]
      },
      {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [{
          color: '#454545'
        }]
      },
      {
        featureType: 'water',
        elementType: 'labels.text.stroke',
        stylers: [{
          color: '#ffffff'
        }]
      }
    ]
  });

  const marker = new google.maps.Marker({
    position: mapCoords,
    map: mapObject,
    title: 'Bigblu.'
  });

  return mapObject;
}

window.initializeMaps = function () {
  $('#contactMap').each(initMap);
};
